import AdvancedSearch from '@nile/components/src/Components/AdvancedSearch/AdvancedSearch';
import {
  onAttributeSelect,
  onValueSearch
} from '@nile/components/src/Pebbles/AdvancedTicketFilter';
import React from 'react';
import { injectIntl } from 'react-intl';

function TicketQueryBuilderForm(props) {
  const { intl } = props;

  return (
    <AdvancedSearch
      {...props}
      currentModule="ticket"
      onAttributeSelect={onAttributeSelect}
      onValueSearch={onValueSearch}
    />
  );
}

export default injectIntl(TicketQueryBuilderForm);
